import { render } from "./nosto-active-value-tag.vue?vue&type=template&id=02f33555"
import script from "./nosto-active-value-tag.vue?vue&type=script&lang=js"
export * from "./nosto-active-value-tag.vue?vue&type=script&lang=js"

import "./nosto-active-value-tag.vue?vue&type=style&index=0&id=02f33555&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__